import {
  attackedPieces,
  unattackedUndefendedPieces,
} from '@domain/analysis/attackedPieces';
import type { OverlayLabel, OverlayPlugin } from '../types';

export const attackedPiecesPlugin: OverlayPlugin = {
  id: 'attackedPieces',
  label: 'Attacked & unprotected pieces',
  compute(ctx) {
    const hits = attackedPieces(ctx.board.fen);
    const unattackedUndefended = unattackedUndefendedPieces(ctx.board.fen);
    const labels: OverlayLabel[] = [];

    for (const h of hits) {
      labels.push({
        sq: h.sq,
        text: String(h.attackerCount),
        position: 'top-right',
        className: 'overlay-attacked__badge--attacker',
      });
      if (h.defenderCount > 0) {
        labels.push({
          sq: h.sq,
          text: String(h.defenderCount),
          position: 'bottom-right',
          className: 'overlay-attacked__badge--defender',
        });
      }
    }

    const squares = [
      ...hits.map((h) => ({
        sq: h.sq,
        className: 'overlay-attacked',
        intensity: h.attackerCount,
      })),
      ...unattackedUndefended.map((sq) => ({
        sq,
        className: 'overlay-unprotected',
        intensity: 1,
      })),
    ];

    return {
      squares,
      labels,
    };
  },
};
